import { useClientStore, useRouterStore } from 'apps/hooks';
import { getSystemCondition } from 'apps/routes/utils';
import { DependencyList, useEffect, useState } from 'react';
import { useDesktopCompatibility } from './useDesktopCompatible';

export type SystemConditionType = ReturnType<typeof getSystemCondition>;

export const useGetSystemCondition = (deps: DependencyList = []) => {
  const routerStore = useRouterStore();
  const { route } = routerStore;
  const clientStore = useClientStore();
  const compatibleWithTab = useDesktopCompatibility({
    feature: 'tab',
  });

  const canBackInHistory = !compatibleWithTab
    ? true
    : !(
        routerStore?.previousRoute?.name === routerStore?.route?.name ||
        routerStore?.previousRoute?.name.includes('workspace')
      );

  const [condition, setCondition] = useState<SystemConditionType>(
    {} as SystemConditionType,
  );

  useEffect(() => {
    setCondition(getSystemCondition());
  }, [route.name, clientStore.currentSpaceData, ...deps]);

  return {
    ...(condition || {}),
    canBackInHistory,
  };
};
